import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  fUser : firebase.User;

  idTokenResult : firebase.auth.IdTokenResult;

  public user : AngularFirestoreDocument;

  constructor(public afAuth: AngularFireAuth, private afFirestore: AngularFirestore) {
    this.afAuth.authState.subscribe(
      (fUser)=>{
        this.fUser = fUser;        
        if(fUser){
           fUser.getIdTokenResult().then(
             (idTokenResult)=>{
               this.idTokenResult = idTokenResult;
             }
           );           
        }
        else{
          this.idTokenResult = null;
        }
      }
    );    
  }

  userHasRole(roles:string[]){    
    return this.fUser 
            && this.idTokenResult.claims.hasOwnProperty("rol")
            && roles
            && roles.indexOf( this.idTokenResult.claims["rol"] ) != -1
            ;    
  }

  login(email, password) : Promise<any>{
    return this.afAuth.signInWithEmailAndPassword(email, password);
  }
  
  logout() : Promise<void>{
    return this.afAuth.signOut();        
  }

}
